import { render, staticRenderFns } from "./ProjectSummary.vue?vue&type=template&id=c1775752&scoped=true&"
import script from "./ProjectSummary.vue?vue&type=script&lang=js&"
export * from "./ProjectSummary.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSummary.vue?vue&type=style&index=0&id=c1775752&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1775752",
  null
  
)

export default component.exports